import { Autocomplete, TextField } from '@mui/material';
import { Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { AllEnums, EnumListKey } from '~/data/enums';
import { Form } from '~/features/RehireDialog/hooks/useRehireEmpForm';
import { useRehireEnumFilteredOptions } from '~/features/RehireDialog/hooks/useRehireEnumFilteredOptions';
import { useSxStyles } from '~/features/RehireDialog/useStyles';

type Props = {
  control: Control<Form>;
  allEnums: AllEnums;
  disabled?: boolean;
};

export const EmploymentTypeComponent = ({ control, allEnums }: Props) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();
  const requiredText = t('fieldIsRequired');

  const filteredOptions = useRehireEnumFilteredOptions(
    control,
    allEnums,
    EnumListKey.EMPLOYMENT_TYPE,
  );

  return (
    <Controller
      control={control}
      name={'rehire.employment.fEmplType'}
      rules={{ required: requiredText }}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Autocomplete
          sx={{ ...sxStyles.selectStyle, ...sxStyles.inputBottomMargin }}
          placeholder={''}
          options={filteredOptions}
          isOptionEqualToValue={(o, v) => o?.code === v?.code}
          getOptionLabel={(c) => c.name}
          value={filteredOptions.find((val) => val.code === value) || null}
          onChange={(e, value) => {
            onChange(value?.code);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              required
              label={t('laEmploymentType')}
              error={!!error}
              helperText={error?.message}
            />
          )}
        />
      )}
    />
  );
};
